import asyncRouter from "@/router/asyncRouter"
import { cloneDeep } from "lodash"

const state = {
  activeModuleName: "",
  havePermissionRouter: [],
  lizhi: false
}

const mutations = {
  Set_module_name: (state, title) => {
    state.activeModuleName = title
  },
  Set_permission_router: (state, title) => {
    state.havePermissionRouter = title
  },
  Set_lizhi: (state, val) => {
    state.lizhi = val
  }
}

const actions = {
  setMduleName ({ commit, state }, moduleName) {
    commit('Set_module_name', moduleName)
  },
  generateRoutes ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      // ⚠️ 关键修复：asyncRouter 是 ES Module 顶层 import 的模块级单例，
      // 整个应用生命周期只会被初始化一次。原代码直接 splice asyncRouter，
      // 会导致：登录/刷新后再次调用 generateRoutes 时，原数据已被污染，
      // 角色匹配错位、路由表不完整，点击导航后进入 404。
      // 修复：必须先 cloneDeep 一份副本，在副本上裁剪。
      const accessRoutes = cloneDeep(asyncRouter)
      for (let i = 0; i < accessRoutes.length; i++) {
        const pitem = accessRoutes[i]
        for (let j = 0; j < pitem.children.length; j++) {
          const sitem = pitem.children[j]
          if (!sitem.meta || sitem.meta.roles.indexOf(data.type) === -1) {
            pitem.children.splice(j, 1)
            j--
          }
        }
        if (pitem.children.length === 0) {
          accessRoutes.splice(i, 1)
          i--
        }
        if (data.type === 6 && data.belong) {
          // 飞手已有所属公司，就把入职申请路由去掉
          commit("Set_lizhi", true)
        }
      }
      commit("Set_permission_router", accessRoutes)
      resolve(accessRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
